module.exports = __webpack_public_path__ + "img/2.eb642b8c.jpg";